/**
 * Fiches de formation (2026-10-09) : celles que la personne RETIENT pour elle
 * et celles qu'elle a LUES, par navigateur (localStorage), comme la coche des
 * guides (`progress.js`) : un confort de lecture, pas une donnée du client.
 *
 * Une fiche est lue quand on l'a parcourue jusqu'au bout dans sa fenêtre.
 */
import { useSyncExternalStore } from 'react';

const READ_KEY = 'palestre_fiches_read_v1';
const PICK_KEY = 'palestre_fiches_pick_v1';

function read(key) {
  try {
    const raw = window.localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

let snap = { read: read(READ_KEY), picked: read(PICK_KEY) };
const subs = new Set();
function subscribe(fn) { subs.add(fn); return () => subs.delete(fn); }
function snapshot() { return snap; }

function put(field, key, id, value) {
  if (!!snap[field][id] === !!value) return;
  const next = { ...snap[field] };
  if (value) next[id] = true; else delete next[id];
  snap = { ...snap, [field]: next };
  try { window.localStorage.setItem(key, JSON.stringify(next)); } catch { /* stockage indisponible */ }
  subs.forEach((fn) => fn());
}

export function setFicheRead(id, value) { put('read', READ_KEY, id, value); }
export function setFichePicked(id, value) { put('picked', PICK_KEY, id, value); }

/** Hook : { read, picked } — tables { [ficheId]: true }. */
export function useFicheProgress() {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}

/* DURÉE ESTIMÉE : les mots qu'on lit (paragraphes, articles de loi, tableaux),
   à 200 mots la minute, arrondie à la minute supérieure. Les sources ne se
   lisent pas, elles se consultent. */
const WORDS_PER_MIN = 200;
const words = (s) => String(s || '').split(/\s+/).filter(Boolean).length;
export function readingMinutes(fiche) {
  let n = words(fiche.title) + words(fiche.summary);
  (fiche.sections || []).forEach((sec) => {
    if (sec.kind === 'sources') return;
    n += words(sec.label);
    (sec.paragraphs || []).forEach((p) => { n += words(p); });
    (sec.articles || []).forEach((a) => { n += words(a.text); });
    if (sec.table) {
      (sec.table.head || []).forEach((c) => { n += words(c); });
      (sec.table.rows || []).forEach((r) => (Array.isArray(r) ? r : []).forEach((c) => { n += words(c); }));
      n += words(sec.table.note);
    }
  });
  return Math.max(1, Math.ceil(n / WORDS_PER_MIN));
}
